import { createIcon } from '@chakra-ui/react';

export const PartyHorn = createIcon({
  displayName: 'PartyHorn',
  viewBox: '0 0 31.556 32',
  path: (
    <>
      <rect
        id="bg"
        width="31.556"
        height="31.556"
        transform="translate(0)"
        fill="#fff"
      />
      <path
        id="Party_Horn_-_L-2"
        data-name="Party Horn - L"
        d="M22.186,11.158a.746.746,0,0,0,.5-.22l3.876-3.876A.744.744,0,0,0,25.51,6.01L21.635,9.886a.746.746,0,0,0,.526,1.272ZM17.274,6.9a.706.706,0,0,0,.245-.045,3.655,3.655,0,0,0,1.372-.866A3.705,3.705,0,0,0,18.906.783a.744.744,0,0,0-1.051,1.051,2.218,2.218,0,0,1,0,3.129,2.178,2.178,0,0,1-.816.5.746.746,0,0,0,.25,1.447Zm14.521,6.79a3.7,3.7,0,0,0-6.1,1.372.744.744,0,1,0,1.4.5,2.213,2.213,0,0,1,3.7-.821.737.737,0,1,0,1.031-1.051Zm-6.815,5.883-5.743,2.644a.611.611,0,0,0-.06-.1l-8.667-8.667c-.035-.03-.075-.045-.11-.07l2.213-4.762L22.706,18.718a.744.744,0,0,0,1.051-1.051L12.912,6.816a.761.761,0,0,0-.646-.205.746.746,0,0,0-.546.421L.57,31.011a.746.746,0,0,0,.145.841.766.766,0,0,0,.536.22.756.756,0,0,0,.31-.07L25.6,20.927a.746.746,0,1,0-.621-1.352ZM2.753,29.824l3.74-8.056L10.824,26.1Zm9.514-4.406L7.179,20.311,9.763,14.8l8.056,8.066Z"
        transform="translate(-0.499 -0.072)"
        fill="currentColor"
      />
    </>
  ),
});
